import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
    selector: 'event-list',
    templateUrl: './event-list.template.html',
    styleUrls: ['./event-list.styles.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class EventList{
    
    @Input() eventObj: any;
    //@Input() content: any;
    private dataService: BehaviorSubject<Object>;

    constructor(
        private coreEffects: CoreEffects,
        private route: ActivatedRoute
    ){
        this.dataService = new BehaviorSubject(null);
        //this.content = this.coreEffects.getAsyncChildDataAsObservable();
    }
    
    ngOnInit() {
      //this.content = 
      //this.content = this.dataService.asObservable();
      //this.coreEffects.getAsyncChildDataAsObservable(this.dataService, this.eventObj, this.route.snapshot.params, false);
      //this.coreEffects.getAsyncChildDataAsObservable2(this.eventObj, this.route.snapshot.params, false);
    }

    ngOnDestroy(){
        if (this.dataService){
          this.dataService.complete();
          //this.dataService.unsubscribe();
          this.dataService = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/events/event-list/event-list.component.ts